export default __webpack_public_path__ + "static/media/java_color_1.a8591155.png";